import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style.css';
import $ from 'jquery';
window.$ = window.jQuery = $;

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload);

// swiper切换
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);


Vue.use(Router)
Vue.use(ElementUI);



/* 路由 */
import router from './router/router'

/* rem */
import '@/utils/rem.js';

/* vuex */
import store from './store'

/* axios */
import axios from './api'
import api from './api/api'
import request from '@/api/index'
Vue.prototype.http = axios;
Vue.prototype.api = api;
Vue.prototype.$postRequest = request.post;
Vue.prototype.$getRequest = request.get;
Vue.prototype.$bus = new Vue();
// 中英文
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
let English = require('@/locales/en-US.js') // 英语
let Vietnamese = require('@/locales/vi-VN.js') // 越南语
let Indonesian = require('@/locales/id-ID.js') // 印尼
let Thai = require('@/locales/th-TH.js') // 泰语
let Russian = require('@/locales/ru-RU.js') // 俄罗斯语
let Arabic = require('@/locales/ar-AE.js') // 阿拉伯语
let Spanish = require('@/locales/es-ES.js') // 西班牙语


const i18n = new VueI18n({
	locale: window.localStorage.getItem("selLanguage")?window.localStorage.getItem("selLanguage"):'1', // 默认语言
	messages: { // 引入语言文件
		'1': English,
		'2': Vietnamese,
		'3': Indonesian,
		'4': Thai,
		'5': Russian,
		'6': Arabic,
		'7': Spanish,
	}
})
Vue.prototype._i18n = i18n;

Vue.config.productionTip = false


document.title = 'QRF ALLOY MANUFACTURER'



router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
